// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import type { State } from "@store/reducers";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, View } from "@components";
import actionCreators from "@modules/reporting/actionCreator";
import {
  selectedReferralDetails,
  selectReferralCommonData,
} from "@modules/reporting/selectors/referral-tracker";
import {
  ReferralEmployeeDetailsSection,
  ReferralDetailsSection,
  ReferralQuestionsTable,
  ReferralAbsenceHistoryTable,
  ReferralLineManagersTable,
  EmployeeReferralAcknowledgementSection,
} from "@modules/shared/components";

type OwnProps = $Exact<{
  data: number,
  clientId: number,
}>;

type PropsFromState = $Exact<{
  details: Object,
  supplierReferralId: ?number,
  referralType: string,
}>;

type PropsFromDispatch = $Exact<{
  toggleReferralDetailsModal: typeof actionCreators.ToggleSupplierReferralDetailsModal,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class WellbeingReferralDetailsModal extends Component<Props> {
  handleCancel = () => {
    this.props.toggleReferralDetailsModal({});
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader className="d-flex justify-content-between" toggle={this.handleCancel}>
          {this.props.t("REFERRAL_DETAILS_BY_ID", { id: this.props.supplierReferralId })}
        </ModalHeader>
        <ModalBody className="d-flex flex-column align-content-center">
          <View gap={10}>
            <ReferralEmployeeDetailsSection
              t={this.props.t}
              data={this.props.details.employeeDetails}
            />
            <ReferralDetailsSection data={this.props.details.referralDetails} />
            <ReferralQuestionsTable data={this.props.details.referralQuestions} />
            <ReferralLineManagersTable data={this.props.details.lineManagers} />
            <ReferralAbsenceHistoryTable data={this.props.details.absenceHistory} />
            <EmployeeReferralAcknowledgementSection data={this.props.details} />
          </View>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleCancel}>
            {this.props.t("CANCEL")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => {
  return {
    details: selectedReferralDetails(state),
    supplierReferralId: selectReferralCommonData(state).supplierReferralId,
    referralType: selectReferralCommonData(state).referralType,
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  toggleReferralDetailsModal: actionCreators.ToggleSupplierReferralDetailsModal,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(WellbeingReferralDetailsModal);
